// extracted by mini-css-extract-plugin
module.exports = {"weekday":"UpcomingDaysForecastItem_weekday__quQBM"};